import React, { useCallback, useState } from 'react'
import { ModalBody } from 'reactstrap'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { ValidationBoundary, Validator, ValidationState } from '@/components/validation'
import { ConfirmFooter } from '@/dialogs/common/confirmFooter'
import context from '@/context'
import { DropDownList } from '@/components/dropDownList'

function BankSelectorDialog (props) {
  const { value, definitionType, existingCodes, onAction } = props

  const [dialogValue, setDialogValue] = useState(value)

  const onChange = useCallback(({ value }) => { setDialogValue(value) }, [setDialogValue])
  const dataSource = useCallback((request, options) =>
    context.api.userRowHeaderService.getLookupBanks(definitionType, existingCodes, request, options), [existingCodes, definitionType])
  const onActionCallback = useCallback(() => { onAction(dialogValue) }, [onAction, dialogValue])

  const renderFooter = ({ isValid }) =>
    <ConfirmFooter primaryButtonText='Common.SaveAndClose'
      icon='save'
      disabled={!isValid}
      {...props}
      onAction={onActionCallback} />

  return <ValidationBoundary>
    <BasicHeader title='Common.SelectBank' {...props} />
    <ModalBody>
      <Validator name='value' value={dialogValue} required>
        <DropDownList
          dataSource={dataSource}
          value={dialogValue}
          onChange={onChange} />
      </Validator>
    </ModalBody>
    <ValidationState render={renderFooter} />
  </ValidationBoundary>
}

export default {
  component: BankSelectorDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/bankSelector.js